import { axiosInstance } from '../Axios';
import { createSlice } from '@reduxjs/toolkit';
import { storeData } from './UiReducer';

const HomeReducer = createSlice({
	name: 'home',
	initialState: {
		success: false,
		error: null,
		loading: false,
	},
	reducers: {
		loginRequest(state, action) {
			state.loading = true;
		},
		loginSuccess(state, action) {
			state.loading = false;
			state.loginInfo = action.payload;
			storeData('loginInfo', action.payload);
			state.error = null;
		},
		loginFail(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
	},
});

const { actions } = HomeReducer;
const config = {
	headers: {
		'Content-Type': 'application/json',
	},
};
const config2 = {
	headers: {
		'Content-Type': 'multipart/form-data',
	},
};
export const { loginRequest, loginSuccess, loginFail } = actions;

export const loginDispatch = (bodyData, navigate) => async (dispatch) => {
	try {
		dispatch(loginRequest());
		const { data } = await axiosInstance.post(
			'/customer/login',
			bodyData,
			config
		);
		console.log('data', data);
		dispatch(loginSuccess(data));
		if (data) {
			navigate('/dashboard');
		} else {
			alert('Failed');
		}
	} catch (error) {
		alert(error.response.data.message);
		dispatch(
			loginFail(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			)
		);
	}
};

export default HomeReducer;
